import React, { Suspense } from 'react';

import { Link, useMatches } from '@tanstack/react-router';
import { Trans, useTranslation } from 'react-i18next';

import PageIntro from '../components/PageIntro';

import type { JSX } from 'react';

const NotFound = (): JSX.Element | null => {
  const matches = useMatches();
  const locale = matches.find((match) => match.context?.locale)?.context?.locale ?? 'nl';

  const { t } = useTranslation('notFound', { lng: locale });

  return (
    <Suspense>
      <PageIntro eyebrow="" title={t('title')}>
        <p>
          <Trans
            i18nKey="description"
            t={t}
            components={{
              a:
  <Link
    className="underline"
    params={{ locale: locale === 'nl' ? undefined : locale }}
    to="/{-$locale}"
  />,
            }}
          />
        </p>
      </PageIntro>
    </Suspense>
  );
};

export default NotFound;
